<template>
  <div style="margin:30px;">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="失信原因" prop="dishonestyReason">
        <el-input v-model="form.dishonestyReason" type="textarea" placeholder="请输入内容" />
      </el-form-item>
      <el-form-item>
        <el-button @click="$emit('onHideModel')">取 消</el-button>
        <el-button type="primary" @click="funcSubmit">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import {reportDishonestyVehicle } from '@/api/transport'
export default {
  name: "DishonestyReason",
  data() {
    return {
      form: {
        code:"",
        dishonestyReason: "",
      },
      rules: {
        dishonestyReason: [
          { required: true, message: "请填写上报车辆失信原因", trigger: "blur" },
          { min: 1, max: 350, message: "长度在 1 到 350 个字符", trigger: "blur" }
        ],
      }
    };
  },
  methods: {
    // 获取详情
    getInfo(code) {
        this.form.code = code
    },
    funcSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
         reportDishonestyVehicle(this.form)
          .then((response) => {
            this.$message({
              type: 'success',
              message: response.msg
            });
          })
          .finally(() => {
            this.$emit("onHideModelAndrefresh");
            this.$refs.form.resetFields();
          })
        } else {
          return false;
        }
      });
    }
  }
};
</script>
